"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: 0,
  overflow: "hidden",
  position: "absolute"
};

// TODO: make a SkipNav component that appears when focus is received
// this component will never be visible so if it has natively focusable
// elements it will stay invisible.

exports.default = function (_ref) {
  var children = _ref.children;

  return _react2.default.createElement("div", { style: style, children: children });
};